import 'css-chunksrc/client/pages/projectPage/documentsPage/documentsPage/preview/defaultRenderer/styles.scss';export default {
  "renderer": "_renderer_g8bbf_1"
};